import React from "react";
import {Redirect} from "react-router-dom";
import {useAppStore} from "../common/app.store.consumer";
import {AppStore} from "../stores/app.store";
import {ProfessionalProfileRoutes} from "../stores/site.map";

interface HomePageProps {
	appStore?: AppStore;
}

@useAppStore()
class Home extends React.Component<HomePageProps> {
	private userStore = this.props.appStore.userStore;
	render() {
		if (this.userStore.hasSubmittedQuestionnaire) {
			return <Redirect to={ProfessionalProfileRoutes.ReportV2} />;
		} else {
			return <Redirect to={ProfessionalProfileRoutes.Questionnaire} />;
		}
	}
}

export default Home;
